<template>
  <form>
    <div class="form-group">
      <label for="inputEmail">Email</label>
      <input
        type="email"
        class="form-control"
        id="inputEmail"
        aria-describedby
        placeholder
        v-model="form.email"
      />
    </div>
    <div class="form-group">
      <label for="title">Ünvan</label>
      <select class="form-control" v-model="form.title">
        <option value="Eczacı">Eczacı</option>
        <option value="Uzman Eczacı">Uzman Eczacı</option>
        <option value="Pratisyen Doktor">Pratisyen Doktor</option>
        <option value="Uzman Doktor">Uzman Doktor</option>
        <option value="Operatör Doktor ">Operatör Doktor</option>
        <option value="Yardımcı Doçent Doktor">Yardımcı Doçent Doktor</option>
        <option value="Doçent Doktor">Doçent Doktor</option>
        <option value="Profesör Doktor">Profesör Doktor</option>
        <option value="Takeda Çalışanı">Takeda Çalışanı</option>
      </select>
    </div>
    <div class="form-group">
      <label for="speciality">Uzmanlık</label>
      <select class="form-control" v-model="form.speciality">
        <option value="Eczacı">Eczacı</option>
        <option value="Aile Hekimleri">Aile Hekimleri</option>
        <option value="Pratisyen">Pratisyen</option>
        <option value="Pediatri">Pediatri</option>
        <option value="Üroloji">Üroloji</option>
        <option value="Acil Tıp">Acil Tıp</option>
        <option value="Allerji-İmmünoloji">Allerji-İmmünoloji</option>
        <option value="Dahiliye">Dahiliye</option>
        <option value="Dermatoloji">Dermatoloji</option>
        <option value="Enfeksiyon">Enfeksiyon</option>
        <option value="Göğüs Cerrahisi">Göğüs Cerrahisi</option>
        <option value="Göğüs Hastalıkları">Göğüs Hastalıkları</option>
        <option value="Gastroenteroloji">Gastroenteroloji</option>
        <option value="KBB">KBB</option>
        <option value="Kalp Damar Cerrahisi">Kalp Damar Cerrahisi</option>
        <option value="Kardiyoloji">Kardiyoloji</option>
        <option value="Nöroloji">Nöroloji</option>
        <option value="Psikiyatri">Psikiyatri</option>
        <option value="Romatoloji">Romatoloji</option>
        <option value="FTR">FTR</option>
        <option value="Geriatri">Geriatri</option>
        <option value="Diş Hekimi">Diş Hekimi</option>
        <option value="Kadın Hastalıkları ve Doğum">Kadın Hastalıkları ve Doğum</option>
        <option value="Diğer">Diğer</option>
      </select>
    </div>

    <div class="form-group">
      <label for="city">Şehir</label>
      <select class="form-control" v-model="form.city">
        <option value="Adana">Adana</option>
        <option value="Adıyaman">Adıyaman</option>
        <option value="Afyon">Afyon</option>
        <option value="Ağrı">Ağrı</option>
        <option value="Aksaray">Aksaray</option>
        <option value="Amasya">Amasya</option>
        <option value="Ankara">Ankara</option>
        <option value="Antalya">Antalya</option>
        <option value="Ardahan">Ardahan</option>
        <option value="Artvin">Artvin</option>
        <option value="Aydın">Aydın</option>
        <option value="Balıkesir">Balıkesir</option>
        <option value="Bartın">Bartın</option>
        <option value="Batman">Batman</option>
        <option value="Bayburt">Bayburt</option>
        <option value="Bilecik">Bilecik</option>
        <option value="Bingöl">Bingöl</option>
        <option value="Bitlis">Bitlis</option>
        <option value="Bolu">Bolu</option>
        <option value="Burdur">Burdur</option>
        <option value="Bursa">Bursa</option>
        <option value="Çanakkale">Çanakkale</option>
        <option value="Çankırı">Çankırı</option>
        <option value="Çorum">Çorum</option>
        <option value="Denizli">Denizli</option>
        <option value="Diyarbakır">Diyarbakır</option>
        <option value="Düzce">Düzce</option>
        <option value="Edirne">Edirne</option>
        <option value="Elazığ">Elazığ</option>
        <option value="Erzincan">Erzincan</option>
        <option value="Erzurum">Erzurum</option>
        <option value="Eskişehir">Eskişehir</option>
        <option value="Gaziantep">Gaziantep</option>
        <option value="Giresun">Giresun</option>
        <option value="Gümüşhane">Gümüşhane</option>
        <option value="Hakkari">Hakkari</option>
        <option value="Hatay">Hatay</option>
        <option value="Iğdır">Iğdır</option>
        <option value="Isparta">Isparta</option>
        <option value="İçel">İçel</option>
        <option value="İstanbul">İstanbul</option>
        <option value="İzmir">İzmir</option>
        <option value="Kahramanmaraş">Kahramanmaraş</option>
        <option value="Karabük">Karabük</option>
        <option value="Karaman">Karaman</option>
        <option value="Kars">Kars</option>
        <option value="Kastamonu">Kastamonu</option>
        <option value="Kayseri">Kayseri</option>
        <option value="Kırıkkale">Kırıkkale</option>
        <option value="Kırklareli">Kırklareli</option>
        <option value="Kırşehir">Kırşehir</option>
        <option value="Kilis">Kilis</option>
        <option value="Kilis">Kocaeli</option>
        <option value="Konya">Konya</option>
        <option value="Kütahya">Kütahya</option>
        <option value="Malatya">Malatya</option>
        <option value="Manisa">Manisa</option>
        <option value="Mardin">Mardin</option>
        <option value="Muğla">Muğla</option>
        <option value="Muş">Muş</option>
        <option value="Nevşehir">Nevşehir</option>
        <option value="Niğde">Niğde</option>
        <option value="Ordu">Ordu</option>
        <option value="Osmaniye">Osmaniye</option>
        <option value="Rize">Rize</option>
        <option value="Sakarya">Sakarya</option>
        <option value="Samsun">Samsun</option>
        <option value="Siirt">Siirt</option>
        <option value="Sinop">Sinop</option>
        <option value="Sivas">Sivas</option>
        <option value="Şanlıurfa">Şanlıurfa</option>
        <option value="Şırnak">Şırnak</option>
        <option value="Tekirdağ">Tekirdağ</option>
        <option value="Tokat">Tokat</option>
        <option value="Trabzon">Trabzon</option>
        <option value="Tunceli">Tunceli</option>
        <option value="Uşak">Uşak</option>
        <option value="Van">Van</option>
        <option value="Yalova">Yalova</option>
        <option value="Yozgat">Yozgat</option>
        <option value="Zonguldak">Zonguldak</option>
      </select>
    </div>
    <button
      type="button"
      class="btn btn-danger btn-lg float-right"
      style="min-width:120px; margin-top:32px;"
      @click="register"
    >İleri</button>
  </form>
</template>

<script>
export default {
  data() {
    return {
      form: {
        email: null,
        title: null,
        speciality: null,
        city: null,
      },
    };
  },
  methods: {
    register() {
      this.$root.consentInfo = Object.assign(this.$root.consentInfo, {
        email: this.form.email,
        title: this.form.title,
        speciality: this.form.speciality,
        city: this.form.city,
        eventId: this.$root.event.id,
      });

      this.$axios
        .post("/postRegister", this.$root.consentInfo)
        .then((res) => {
          window.location.href = res.data.eventUrl;
        })
        .catch((error) => {
          if (error.response.data) {
            let status = error.response.data.status;

            if (status == "failed") {
              $("#tcIdModal").modal("show");
            } else if (status == "smmrequired") {
              this.$router.push({ name: "smmrequired" });
            }
          }
        });
    },
  },
};
</script>

<style>
</style>